export default __webpack_public_path__ + "static/media/icon_registro.a6cf12d7.svg";